var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    x: 2,
    y: 2,
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 16.63 12.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 6.83a3.45 3.45 0 0 1-2.49-1 3.25 3.25 0 0 1-1-2.42 3.2 3.2 0 0 1 1-2.42 3.45 3.45 0 0 1 2.5-1 3.44 3.44 0 0 1 2.49 1 3.2 3.2 0 0 1 1 2.42 3.24 3.24 0 0 1-1 2.42 3.44 3.44 0 0 1-2.49 1Zm0-1.68a1.74 1.74 0 0 0 1.26-.5 1.7 1.7 0 0 0 .54-1.23 1.67 1.67 0 0 0-.5-1.22 1.7 1.7 0 0 0-1.3-.51 1.7 1.7 0 0 0-1.26.49 1.64 1.64 0 0 0-.51 1.23 1.68 1.68 0 0 0 .51 1.23 1.7 1.7 0 0 0 1.26.5Zm7.78-5h1.83L5.31 12.16H3.49Zm1.82 12.12a3.45 3.45 0 0 1-2.48-1 3.22 3.22 0 0 1-1-2.41 3.28 3.28 0 0 1 1-2.44 3.4 3.4 0 0 1 2.5-1 3.4 3.4 0 0 1 2.5 1 3.28 3.28 0 0 1 1 2.44 3.25 3.25 0 0 1-1 2.41 3.48 3.48 0 0 1-2.5 1Zm0-1.67a1.75 1.75 0 0 0 1.26-3 1.67 1.67 0 0 0-1.26-.5 1.64 1.64 0 0 0-1.24.5 1.73 1.73 0 0 0 1.25 3Z"
  })));
};
export default SvgDiscount;